const routes = {
  name: 'Food & Inventory',
  icon: 'mdi-clipboard-outline',
  path: '/reports/timhortons/controls/',
  children: [
    {
      path: '/reports/timhortons/controls/foodDashboard',
      meta: { id: 'reports-thControlsFoodDashboard' },
      name: 'Food At A Glance',
      component: () => import('./dashboard/FoodDashboard.vue'),
      permissions: ['mtFood'],
    },
    {
      path: '/reports/timhortons/controls/inventoryVariance',
      meta: { id: 'reports-thControlsInventoryVariance' },
      name: 'Inventory Variance',
      component: () => import('./InventoryVariance.vue'),
      permissions: ['mtFood'],
    },
    {
      path: '/reports/timhortons/controls/usageFoodCost',
      meta: { id: 'reports-thControlsUsageFoodCost' },
      name: 'Food Cost',
      component: () => import('./UsageFoodCost.vue'),
      permissions: ['mtFood'],
    },
    {
      path: '/reports/timhortons/controls/wasteVariance',
      meta: { id: 'reports-thControlsWasteVariance' },
      name: 'Waste Variance',
      component: () => import('./WasteVariance.vue'),
      permissions: ['mtFood'],
    },
  ],
};

export default routes;
